export const zero = _ => 0;
//# sourceMappingURL=zero.js.map
